import { ChangeDetectorRef, Component, ElementRef, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScriptLoaderService, UtilService } from 'src/app/shared/services';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

declare const google: any;

@Component({
  selector: 'app-search-select',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './search-select.component.html',
  styleUrls: ['./search-select.component.scss']
})
export class SearchSelectComponent {
  private readonly scriptLoader = inject(ScriptLoaderService);
  private readonly util = inject(UtilService);
  private readonly cdr = inject(ChangeDetectorRef);

  @Input() formGroup: FormGroup;
  @Input() control: FormControl;
  @Input() controlKey: string = '';
  @Input() theme: string = 'safTheme';
  @Input() placeholder: string = 'Search here';
  @Input() placeType = '(cities)';
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  @Output() triggerOnBlur: EventEmitter<any> = new EventEmitter();

  @ViewChild('inputRef', { static: true }) inputRef!: ElementRef<HTMLInputElement>;

  searchControl = new FormControl('');

  address: any = {};
  selected = '';
  isLoading = false;

  ngOnInit() {
    if (this.controlKey === 'city') {
      this.scriptLoader.newLoad('googlemaps').then(res => {
        this.initGoogleAutocomplete();
      }).catch(err => { });
    }
  }

  ngAfterViewInit() {
    const preValue = this.control?.value;
    if (preValue) {
      this.searchControl.setValue(preValue);
      this.selected = preValue?.full_name || preValue?.name || preValue;
      this.searchControl.disable();
    }
  }

  onBlur() {
    this.triggerOnBlur.emit(this.searchControl.value);
  }

  initGoogleAutocomplete() {
    if (typeof google === 'undefined') return;
    const autocomplete = new google.maps.places.Autocomplete(this.inputRef.nativeElement, {
      types: [`${this.placeType}`],
      // componentRestrictions: { country: ['us', 'in', 'ae', 'gb'] } // optional
    });
    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      this.formateResult(place.address_components, place.formatted_address);
    });
  }

  formateResult(addressComponent: any[], formattedAddress: string) {
    this.address = { formatted_address: formattedAddress };
    for (const item of addressComponent) {
      if (item.types.includes('locality')) {
        this.address.address_1 = item.long_name;
      } else if (item.types.includes('administrative_area_level_1')) {
        this.address.address_2 = item.long_name;
      } else if (item.types.includes('country')) {
        this.address.address_3 = item.long_name;
      } else if (item.types.includes('postal_code')) {
        this.address.postal_code = item.long_name;
      }
    }
    this.selectOption(this.address);
  }

  clear() {
    this.selected = '';
    this.searchControl.enable();
    this.searchControl.setValue('');
    this.onSelect.emit('');
    setTimeout(() => {
      this.util.doc.getElementById(`input-${this.controlKey}`)?.focus()
    }, 10);
  }

  displayFn(item: any): string {
    return item?.name || item?.full_name || '';
  }

  selectOption(option: any) {
    this.selected = option?.full_name || option?.name || option;
    this.searchControl.disable();
    this.onSelect.emit(option);
    this.cdr.detectChanges();
  }

}
